import axios from "axios";
import { notify } from "./alertsHelper";
import { getAccessToken, isAuthorizationHeaderAllowed } from "./authHelper";
import { LOGOUT } from "_constants";
import { getSuccessActionType } from "./reduxHelper";
import {
  isRouteExcludedFromErrorMessage,
  isRouteExcludedFromSuccessMessage,
} from "./routeHelper";

// let navigate;
let store;

export const injectStore = (_store) => {
  store = _store;
};

export const injectNavigate = (_navigate) => {
  // navigate = _navigate;
};

const customerManagementRequest = axios.create({
  baseURL: process.env.REACT_APP_CUSTOMER_MANAGEMENT_BASE_URL,
});

const paymentRequest = axios.create({
  baseURL: process.env.REACT_APP_PAYMENT_BASE_URL,
});

const socialTradingRequest = axios.create({
  baseURL: process.env.REACT_APP_SOCIAL_TRADING_BASE_URL,
});

const handleSuccessResponse = (response) => {
  const {
    status,
    data,
    config: { method, url },
  } = response;
  if (status === 200 || status === 201) {
    if (
      (method === "post" || method === "put") &&
      !isRouteExcludedFromSuccessMessage(url)
    ) {
      notify({
        message: "Success",
        placement: "topRight",
        success: true,
        description: data?.message || "",
      });
    }
  }
  return response;
};

const handleLogout = (status, url, description) => {
  let logoutErrorMessage = "";
  if (status === 401 || status === 403) {
    store.dispatch({ type: getSuccessActionType(LOGOUT) });
    if (status !== 403) {
      logoutErrorMessage =
        description || "Session has expired. Please log in again";
    }
  }
  return { logoutErrorMessage };
};

const handleErrorResponse = (error) => {
  const {
    status,
    data,
    config: { url },
  } = error.response;
  if (status >= 400) {
    let description =
      data?.error?.message ||
      data?.error ||
      data?.message ||
      error?.message ||
      "An unexpected error has occurred. Sorry about that. Please contact our support for further assistance";
    const { logoutErrorMessage } = handleLogout(status, url, description);
    description = logoutErrorMessage || description;
    if (!isRouteExcludedFromErrorMessage(url)) {
      notify({
        message: "Error",
        description: description,
        placement: "topRight",
        error: true,
      });
    }
  }
  return Promise.reject(error);
};

const appendPayloadToRequestData = (request) => {
  const accessToken = getAccessToken();
  if (accessToken && isAuthorizationHeaderAllowed(request?.url)) {
    request.headers = {
      ...(request?.headers || {}),
      Authorization: `Bearer ${accessToken}`,
    };
  }
};

customerManagementRequest.interceptors.request.use((request) => {
  request.headers["Content-Type"] = "application/json";
  appendPayloadToRequestData(request);
  return request;
});

customerManagementRequest.interceptors.response.use(
  handleSuccessResponse,
  handleErrorResponse
);

paymentRequest.interceptors.request.use((request) => {
  request.headers["Content-Type"] = "application/json";
  appendPayloadToRequestData(request);
  return request;
});

paymentRequest.interceptors.response.use(
  handleSuccessResponse,
  handleErrorResponse
);

socialTradingRequest.interceptors.request.use((request) => {
  request.headers["Content-Type"] = "application/json";
  appendPayloadToRequestData(request);
  return request;
});

socialTradingRequest.interceptors.response.use(
  handleSuccessResponse,
  handleErrorResponse
);

export { customerManagementRequest, paymentRequest, socialTradingRequest };
